import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useHistory } from 'react-router-dom';
import './index.scss';
import { fetchSlotsAsync } from '../../services';
import { transformAppointmentData } from '../../utils';
import Button from 'b2b-ui-components-lib/lib/components/button';
import moment from 'moment';
import { DATE_FORMATS, START_END_DATE_DIFF } from 'featureLib/AppointmentEdl/constants';
import { addDays, trackAnalytics } from 'common/utils/app.utils';
import WidgetLoader from './WidgetLoader';
import { fetchLineItems } from 'dedicated/components/plan-and-configuration/configure-plan-pricing.service';
import { getCurrentLead, getCurrentOrder } from 'tokenGeneration/lead.util';
const dPlus4FromCurrentDate = new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate() + 4);
const dPlus2FromCurrentDate = new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate() + 2);

const SchedulingWidget = ({
  id = 'schedule-appointment',
  dateTitle = 'PICK A DATE',
  calendarProps = {
    title: 'View Other Dates',
    className: 'custom_calendar',
    startDate: dPlus4FromCurrentDate,
    value: dPlus4FromCurrentDate,
    maxDate: new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate() + 28),
    minDate: dPlus4FromCurrentDate
  },
  apiProps = {
    baseurl: '',
    endpoint: '',
    params: {},
    authToken: null
  },
  timeTitle = 'PICK A TIME SLOT',
  noSlotWarningMessage = 'No slots available on the selected day. Please try with a different date.',
  onDateClick = () => {},
  onSlotClick = () => {},
  onConfirmClick = () => {},
  // defaultAppointmentData = {
  //   appointmentDate: "2023-12-15",
  //   timeInterval: {
  //     start: "08:30:00",
  //     finish: "17:30:00"
  //   }
  // },
  orderDetail,
  planDetail,
  lineitems
}) => {
  const isSMB = apiProps?.params?.segment !== 'ENTERPRISE';

  if (isSMB) {
    calendarProps.startDate = dPlus2FromCurrentDate;
    calendarProps.value = dPlus2FromCurrentDate;
    calendarProps.minDate = dPlus2FromCurrentDate;
  }

  const calendarRef = useRef(null);

  const [showCalendar, setShowCalendar] = useState(false);
  const [appointmentData, setAppointmentData] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [loader, showLoader] = useState(false);
  const history = useHistory();
  const selectedAppointmentSlots = useMemo(() => {
    const selectedAppointment = appointmentData.find((item) => item.isSelected);

    return selectedAppointment?.slotList || [];
  }, [appointmentData]);

  const toggleCalendar = useCallback(() => {
    setShowCalendar((showCalendar) => !showCalendar);
    // const data = history && history.location && history.location.state && history.location.state.orderData;
    // const data = getCurrentLead();
    const details = getCurrentOrder();
    trackAnalytics({
      eVar9: `b2b|DEDICATED_INTERNET|buy|confirm installations|site readiness widget|schedule appointement|view other dates`,
      prop0: `b2b|${details?.lead?.customer?.segment}|${details?.serviceType}`,
      prop15: details?.customerEmail || '',
      prop17: `${details?.lead?.customer?.authorizedSignatory?.firstName || ''} ${details?.lead?.customer?.authorizedSignatory?.lastName || ''}`,
      prop14: details?.lead?.customer?.authorizedSignatory?.phoneNumber || '',
      prop35: details?.companyAddress?.officeName || '',
      prop39: details?.lead?.customer?.segment || '',
      prop40: details?.serviceType || '',
      prop37: details?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      prop21: details?.lead?.connectivityLineItems?.[0]?.feasibilityId || '', //feasibility request id
      // Prop23=<link id>
      prop9: details?.companyAddress?.pincode || '',
      prop36: details?.companyAddress?.officeName || '',
      prop20: details?.companyAddress?.addressLine1 || '',
      prop26: details?.lead?.connectivityLineItems?.[0]?.planDetail?.speed || '',
      // Prop28=<site type>
      prop10: details?.orderId || '',
      prop29: details?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media || '',
      prop22: details?.lead?.connectivityLineItems?.[0]?.planDetail?.planPeriod || '',
      prop18: details?.lead?.planDetail?.totalPrice || '',
      prop1: details?.purchaseOrder?.poNumber || '',
      prop24: details?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: details?.purchaseOrder?.purchaseOrderDate || '',
      prop2: details?.purchaseOrder?.poAmount || '',
      prop3: details?.billingType || '',
      prop4: details?.billingCycle || '',
      prop5: details?.lead?.customer?.panNumber || '',
      prop16: details?.companyAddress?.city || '',
      prop37: details?.lead?.connectivityLineItems?.[0]?.customerNeedDate || '',
      prop38: details?.fiscalCode?.id || ''
    });
  }, []);

  // const handleOutsideCalendarClick = event => {
  //     if(!calendarRef?.current?.contains(event.target)) {
  //         setShowCalendar(false);
  //     }
  // };

  const handleDateClick = (e, selectedDateItem) => {
    e.preventDefault();
    onDateClick(selectedDateItem);
    setSelectedDate(selectedDateItem);

    const appointmentDataCpy = [...appointmentData];

    appointmentDataCpy?.map((item) => {
      if (item.title === selectedDateItem.title) {
        item.isSelected = true;

        if (item.slotList.length > 0) {
          item.slotList.map((item, index) => {
            item.isSelected = index === 0 ? true : false;
          });
        }
      } else {
        item.isSelected = false;

        if (item.slotList.length > 0) {
          item.slotList.map((item) => {
            item.isSelected = false;
          });
        }
      }
    });

    setAppointmentData(appointmentDataCpy);
  };

  const handleSlotClick = (e, selectedSlotItem, index) => {
    e.preventDefault();
    onSlotClick(selectedSlotItem);
    setSelectedTime(selectedSlotItem);

    const appointmentDataCpy = [...appointmentData];

    appointmentDataCpy?.map((item) => {
      if (item.isSelected) {
        if (item.slotList.length > 0) {
          item.slotList.map((slotItem, slotIndex) => {
            if (slotIndex === index) {
              slotItem.isSelected = true;
            } else {
              slotItem.isSelected = false;
            }
          });
        }
      }
    });

    setAppointmentData(appointmentDataCpy);
  };

  // useEffect(() => {
  //     document.addEventListener('click', handleOutsideCalendarClick, true);
  //     return () => {
  //         document.removeEventListener('click', handleOutsideCalendarClick, true);
  //     }
  // }, []);

  const fetchSlots = async () => {
    try {
      showLoader(true);
      const fetchSlotUrl = `${apiProps.baseurl}${apiProps.endpoint}`;
      const res = await fetchSlotsAsync(fetchSlotUrl, apiProps.params, apiProps.authToken);

      if (res?.status === 200) {
        showLoader(false);
        const data = res?.data;
        const transformedData = transformAppointmentData(data);

        let selectedDate = '';
        let selectedTime = '';

        transformedData?.map((item) => {
          if (item.isSelected) {
            selectedDate = item;
            if (item.slotList.length > 0) {
              item.slotList.map((slotItem, slotIndex) => {
                if (slotItem.isSelected) {
                  selectedTime = slotItem;
                }
              });
            }
          }
        });

        setSelectedDate(selectedDate);
        setSelectedTime(selectedTime);
        setAppointmentData(transformedData);
      }
    } catch (error) {
      showLoader(false);
      throw new Error(error.message);
    }
  };

  const handleConfirmClick = () => {
    // const lead = getCurrentLead();
    const order = getCurrentOrder();
    // console.log(lead,order)
    trackAnalytics({
      eVar0: `b2b|DEDICATED_INTERNET|buy|confirm installations|site readiness widget|schedule appointement|confirm`,
      prop0: `b2b|${order?.lead?.customer?.segment}|${order?.serviceType}`,
      prop15: order?.customerEmail || '', //email address
      prop17: `${order?.lead?.customer?.authorizedSignatory?.firstName || ''} ${order?.lead?.customer?.authorizedSignatory?.lastName || ''}`, //full name
      prop14: order?.lead?.customer?.authorizedSignatory?.phoneNumber || '', //phone number
      prop35: order?.companyAddress?.officeName || '',
      prop39: order?.lead?.customer?.segment || '',
      prop40: order?.serviceType || '',
      prop37: order?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      // prop21=<feasibility request id>
      // Prop23=<link id>
      prop9: order?.companyAddress?.pincode || '',
      prop36: order?.lead?.customer?.authorizedSignatory?.companyName || '',
      prop20: order?.companyAddress?.addressLine1 || '',
      // Prop26=<bandwidth>
      // Prop28=<site type>
      prop10: order?.orderId || '',
      // Prop29=<media type>
      // Prop22=<contract period>
      prop18: order?.lead?.planDetail?.totalPrice || '',
      prop1: order?.purchaseOrder?.poNumber || '',
      prop24: order?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: order?.purchaseOrder?.purchaseOrderDate || '',
      prop2: order?.purchaseOrder?.poAmount || '',
      prop3: order?.billingType || '',
      prop4: order?.billingCycle || '',
      prop5: order?.lead?.customer?.panNumber || '', //<account number>
      prop16: order?.companyAddress?.city || '',
      // Prop7=<full name of site contact details>
      // Prop8=<mobile number of site contact details>
      // Prop9=<email address of site contact details>
      // Prop37=<customer need by date>
      prop38: order?.fiscalCode?.id || ''
      // Prop11=<full name of CPM>
      // Prop12=<mobile number of CPM>
      // Prop13=<email address of CPM>
    });
    onConfirmClick(selectedDate, selectedTime);
  };

  const handleCalendarChange = (value) => {
    const startDate = new Date(value);
    const startDateParsed = moment(startDate).format(DATE_FORMATS.YYYY_MM_DD);
    const startDatePlus4 = addDays(value, isSMB ? START_END_DATE_DIFF : START_END_DATE_DIFF);
    const endDateParsed = moment(startDatePlus4).format(DATE_FORMATS.YYYY_MM_DD);
    setShowCalendar(false);

    if (isSMB) {
      apiProps.params = {
        ...apiProps.params,
        appointmentStartDate: startDateParsed,
        appointmentEndDate: endDateParsed
      };
    } else {
      apiProps.params = {
        ...apiProps.params,
        startDate: startDateParsed,
        endDate: endDateParsed,
        appointmentStartDate: startDateParsed,
        appointmentEndDate: endDateParsed
      };
    }

    fetchSlots();
  };
  useEffect(() => {
    // if(defaultAppointmentData && defaultAppointmentData.appointmentDate && defaultAppointmentData.timeInterval.start && defaultAppointmentData.timeInterval.finish) {
    //   apiProps.params = {
    //     ...apiProps.params,
    //     startDate: defaultAppointmentData.appointmentDate,
    //     endDate: new Date(defaultAppointmentData.appointmentDate)
    //   }
    // }
    fetchSlots();
  }, []);

  if (loader) {
    return <WidgetLoader />;
  }

  return (
    <div id={id} className="schedule_appointment_widget">
      <div className="date_section">
        <div className="title_section">
          <div className="title">{dateTitle}</div>
          <div className="calendar_container">
            <div className="calendar_title" role="button" onClick={toggleCalendar}>
              {calendarProps.title}
            </div>
            {showCalendar && (
              <div className="calendar" ref={calendarRef}>
                <Calendar
                  className={calendarProps.className}
                  defaultActiveStartDate={calendarProps.startDate}
                  defaultValue={calendarProps.value}
                  // maxDate={calendarProps.maxDate}
                  minDate={calendarProps.minDate}
                  onChange={handleCalendarChange}
                />
              </div>
            )}
          </div>
        </div>
        <div className="row_container">
          {appointmentData?.map((date) => (
            <div
              className={classNames({
                box: true,
                selected: date.isSelected
              })}
              key={date.title}
              role="button"
              onClick={(e) => handleDateClick(e, date)}
            >
              <div className="box_title">{date.title}</div>
              <div className="box_subtitle">{date.subtitle}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="time_section">
        <div className="title_section">
          <div className="title">{timeTitle}</div>
        </div>
        <div className="row_container">
          {appointmentData?.length === 0 && selectedAppointmentSlots?.length === 0 && (
            <div className="no_available_slots">
              <div className="no_slots_container">
                <i className="aeh-icon-outlined-info info_icon" />
                <span className="warning_message">{noSlotWarningMessage}</span>
              </div>
            </div>
          )}
          {selectedAppointmentSlots?.length > 0 &&
            selectedAppointmentSlots.map((slot, index) => (
              <div
                className={classNames({
                  capsule: true,
                  selected: slot.isSelected
                })}
                key={slot.title}
                role="button"
                onClick={(e) => handleSlotClick(e, slot, index)}
              >
                <div className="capsule_title">{slot.title}</div>
              </div>
            ))}
        </div>
      </div>
      <div className="submit_section">
        <Button onClick={handleConfirmClick} disabled={appointmentData.length === 0}>
          Confirm
        </Button>
      </div>
    </div>
  );
};

export default SchedulingWidget;
